import useCurrentProject from '@/biz/useCurrentProject.mjs'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../MenuButton.jsx'

export default function MenuButtonSetAsCurrentProject(props) {
    const [, setCurrentProject] = useCurrentProject()
    const map = useMapContext()
    const {mapTypeCode, prjId, sVer} = map.data

    if ('SA_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => runAsync(
        () => setCurrentProject(prjId, sVer),
        {action: '设置当前项目'}
    )

    return (
        <MenuButton
            onClick={onClick}
            {...props}
        >
            设为当前项目
        </MenuButton>
    )
}
